export default __webpack_public_path__ + "static/media/E_Forms.813d603d.png";